import { resolveProjectionDayCap } from '../projectionDayCap'

const getOpenForDaySpan = schedule => {
  const availability = schedule?.availability
  if (!availability || availability.mode !== 'fixed_duration') return null
  const openFor = availability.open_for || availability.openFor
  if (!openFor) return null
  const unit = String(openFor.unit || '').toLowerCase()
  if (!unit.startsWith('day')) return null
  const span = Math.floor(Number(openFor.value))
  if (!Number.isFinite(span) || span <= 1) return null
  return span
}

/** Last study day this deploy occurrence stays open (inclusive), or null when not a multi-day open_for. */
export const resolveOpenForStudyDayEnd = (deployStudyDay, schedule, studyEndDay) => {
  const span = getOpenForDaySpan(schedule)
  if (!span) return null
  const cap = resolveProjectionDayCap(studyEndDay)
  const start = Math.floor(Number(deployStudyDay))
  if (!Number.isFinite(start) || start < 1) return null
  return Math.min(start + span - 1, cap)
}

/** @deprecated Use resolveOpenForStudyDayEnd on each deploy day instead of flattening to daily rows. */
export const expandOpenForDaySpans = (occurrenceDays = [], schedule, studyEndDay) => {
  const span = getOpenForDaySpan(schedule)
  if (!span) return occurrenceDays

  const cap = resolveProjectionDayCap(studyEndDay)
  const days = new Set()
  occurrenceDays.forEach(day => {
    for (let offset = 0; offset < span; offset += 1) {
      const d = day + offset
      if (d >= 1 && d <= cap) days.add(d)
    }
  })
  return [...days].sort((a, b) => a - b)
}
